import React from 'react';
import PanelHelpBadge from '../../PanelHelpBadge';

function Step({ label, value, rate, maxValue }) {
  const width = maxValue > 0 ? Math.max(6, Math.round((value / maxValue) * 100)) : 6;
  return (
    <li className="space-y-1">
      <div className="flex items-center justify-between text-sm">
        <span className="font-semibold text-slate-700 dark:text-slate-200">{label}</span>
        <span className="text-slate-500 dark:text-slate-400">{Number(value || 0).toLocaleString('tr-TR')} ({Number(rate || 0).toLocaleString('tr-TR')}%)</span>
      </div>
      <div className="h-2 rounded-full bg-slate-200 dark:bg-slate-800">
        <div className="h-2 rounded-full bg-primary" style={{ width: `${width}%` }} />
      </div>
    </li>
  );
}

export default function FunnelOverviewCard({ funnel, onOpenDrawer }) {
  const steps = [
    { label: 'Görüntüleme', value: Number(funnel?.view || 0), rate: 100 },
    { label: 'Seçim', value: Number(funnel?.select || 0), rate: Number(funnel?.conversion?.viewToSelect || 0) },
    { label: 'Plan', value: Number(funnel?.plan || 0), rate: Number(funnel?.conversion?.selectToPlan || 0) },
    { label: 'Pişirme', value: Number(funnel?.cook || 0), rate: Number(funnel?.conversion?.planToCook || 0) }
  ];
  const maxValue = Math.max(1, ...steps.map((x) => x.value));

  return (
    <section className="min-h-[248px] rounded-xl border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-[#101922]">
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <h3 className="text-sm font-black text-slate-900 dark:text-white">Funnel Özeti</h3>
          <PanelHelpBadge
            title="Funnel Özeti"
            description="Görüntüleme → Seçim → Plan → Pişirme akışındaki geçiş kalitesini tek kartta gösterir."
            interpretation="Düşüş yüksekse ilgili adımın içerik/öneri kalitesi kontrol edilmelidir."
            metricExample="Görüntüleme yüksek, seçim düşükse ilk öneri eşleşmesi zayıf olabilir."
          />
        </div>
        <button
          type="button"
          onClick={() => onOpenDrawer('funnel')}
          className="text-xs font-bold text-primary hover:underline"
        >
          Detaya git →
        </button>
      </div>

      <ul className="mt-3 space-y-3">
        {steps.map((step) => (
          <Step key={step.label} label={step.label} value={step.value} rate={step.rate} maxValue={maxValue} />
        ))}
      </ul>

      <div className="mt-3 rounded-lg border border-slate-200 bg-slate-50 p-2 text-xs text-slate-600 dark:border-slate-800 dark:bg-slate-900 dark:text-slate-300">
        Düşüş: Görüntüleme→Seçim {Number(funnel?.dropOff?.viewToSelect || 0).toLocaleString('tr-TR')}% | Seçim→Plan {Number(funnel?.dropOff?.selectToPlan || 0).toLocaleString('tr-TR')}% | Plan→Pişirme {Number(funnel?.dropOff?.planToCook || 0).toLocaleString('tr-TR')}%
      </div>
      <div className="mt-2 rounded-lg border border-indigo-200 bg-indigo-50 p-2 text-xs text-indigo-900 dark:border-indigo-700 dark:bg-indigo-900/20 dark:text-indigo-100">
        <p className="font-semibold">
          Bugünün ana kırılması: {String(funnel?.primaryBreak?.label || 'Kırılma tespit edilemedi')} (%{Number(funnel?.primaryBreak?.lossRate || 0).toLocaleString('tr-TR')} kayıp)
        </p>
        <p className="mt-1 text-indigo-800 dark:text-indigo-200">
          Neden: {String(funnel?.primaryBreak?.reason || 'Yeterli sinyal yok.')}
        </p>
        {funnel?.primaryBreak?.lockedByLowSample ? (
          <p className="mt-1 font-semibold text-amber-700 dark:text-amber-300">
            Kilit: {String(funnel?.primaryBreak?.lockReason || 'Düşük örneklem')}
          </p>
        ) : null}
        <p className="mt-1">
          Birincil aksiyon: <span className="font-semibold">{String(funnel?.primaryBreak?.primaryAction || 'Öneri yok')}</span>
        </p>
        <p className="mt-0.5">
          İkincil aksiyon: <span className="font-semibold">{String(funnel?.primaryBreak?.secondaryAction || 'Öneri yok')}</span>
        </p>
      </div>
    </section>
  );
}
